import React from 'react';
import classNames from 'classnames';

import styles from './MoonshotBox.less';

export const MoonshotBox: React.FunctionComponent<{ className?: string }> = ({
  children,
  className,
}) => <div className={classNames(styles.box, className)}>{children}</div>;
